"use client";

import { useState } from "react";

import "../asstes/styles/AnimatedBlogCards.scss";
import FinalAuthority from "../asstes/images/private-council/Final-Authority.jpg";
import NoDelegationLeft from "../asstes/images/private-council/No-Delegation-Left.jpg";
import IrreversibleConsequence from "../asstes/images/private-council/Irreversible-Consequence.jpg";

const cards = [
  {
    title: "Final Authority",
    desc: "You carry the decision.",
    image: FinalAuthority,
  },
  {
    title: "Irreversible Consequence",
    desc: "The outcome will shape lives, institutions, or trajectories.",
    image: IrreversibleConsequence,
  },
  {
    title: "No Delegation Left",
    desc: "No board, role, consultant, or framework can absorb what must be carried next.",
    image: NoDelegationLeft,
  },
];

const styles = `
 

`;

export default function AnimatedBlogCards() {
  const [active, setActive] = useState(1);

  return (
    <>
      <div className="cards-wrapper">
        {cards.map((card, i) => (
          <div
            key={i}
            className={`card ${active === i ? "active" : ""}`}
            onMouseEnter={() => setActive(i)}
          >
            <div className="image-wrapper">
              <img src={card.image.src ?? card.image} alt={card.title} />
            </div>

            <div className="text p-2">
              <h3>{card.title}</h3>

           
              <div className="slide-reveal">
                <p>{card.desc}</p>
                <span className="meta-tag">{card.meta}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
